import {FAILURE, PENDING, SUCCESS} from '../../constants'
import {getGroup as getGroupAPI} from '../../../services/groups'

export async function getGroup(dispatch, {group_id, params = null}) {
  try {
    dispatch({type: PENDING})
    let response = await getGroupAPI({group_id, params})
    dispatch({type: SUCCESS, payload: response})
  } catch (e) {
    console.log(`Get Group Failed: ${group_id}`)
    dispatch({type: FAILURE, payload: e})
  }
}
